import React from 'react'
import { IntrigrationSec } from './intrigrationSec'

export const IntrigrationSubscriptionsSubscriptionList = () => {
  return (
    <>
    <IntrigrationSec /> 
    </>
  )
}
